import { useEffect, useMemo } from 'react';
import { ApplicationStatusType } from '@apply/constants';
import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';
import { Applications } from './components/Applications/Applications';
import { Incomplete } from './components/Incomplete/Incomplete';
import { IBridgeApplicationGridRecord } from '@apply/api/src/api/applicationApi';
import { useState } from 'react';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import { ApplicationApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import './styles/_bridgeApplications.scss';
import { incompleteTabRender } from './common/functions/renderers/incompleteTabRender';
// Temp Modal Demo while we construct Modals
export const BridgeApplications = () => {
    const applicationApi = new ApplicationApi.ApplicationApi(applicationInsights);
    const [isLoading, set_isLoading] = useState(true);
    const [bridgeData, set_bridgeData] = useState<IBridgeApplicationGridRecord[]>();
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [headerActions, set_headerActions] = useState<React.ReactNode>(null);
    useEffect(() => {
        const loadData = async () => {
            const response = await applicationApi.getBridgeApplications();
            set_bridgeData(response.result);
        };

        loadData();
    }, []);

    useEffect(() => {
        if (!bridgeData) return;
        // Page has data, grids are rendering underneath.
        // Keep mask for a brief moment to avoid flicker.
        requestAnimationFrame(() => {
            setTimeout(() => {
                set_isLoading(false);
            }, 250);
        });
    }, [bridgeData]);

    const incompleteApps = useMemo(
        () => bridgeData?.filter((x) => x.applicationStatusTypeId === ApplicationStatusType.Incomplete),
        [bridgeData]
    );

    const submittedApps = bridgeData?.filter(
        (x) =>
            x.applicationStatusTypeId === ApplicationStatusType.SubmittedByApplicant ||
            x.applicationStatusTypeId === ApplicationStatusType.SubmittedForReview ||
            x.applicationStatusTypeId === ApplicationStatusType.Appraise ||
            x.applicationStatusTypeId === ApplicationStatusType.ConvertedToLoan
    );

    return (
        <>
            <SectionHeaderBar title={'Apps'}>{headerActions}</SectionHeaderBar>
            <div
                className='main-content'
                style={{ padding: 0 }}
            >
                <TabPanel
                    focusStateEnabled={false}
                    swipeEnabled={false}
                    onSelectionChanged={(e) => {
                        const index = e.component.option('selectedIndex') ?? 0;
                        setActiveTabIndex(index);
                        set_headerActions(null); // reset on tab change
                    }}
                >
                    <Item title='Active'>
                        <Applications
                            data={submittedApps}
                            isActive={activeTabIndex === 0}
                            set_headerActions={set_headerActions}
                            isLoading={isLoading}
                        />
                    </Item>
                    <Item
                        title='Incomplete'
                        tabRender={(tab) => incompleteTabRender(tab, incompleteApps)}
                    >
                        <Incomplete
                            data={incompleteApps}
                            isActive={activeTabIndex === 1}
                            set_headerActions={set_headerActions}
                            isLoading={isLoading}
                        />
                    </Item>
                </TabPanel>
            </div>
        </>
    );
};
